//@flow
export const QUOTA_TYPE_ADVANCED = 0;
export const QUOTA_TYPE_WALKUP = 1;
export const QUOTA_TYPE_ADVANCED_KEY = 'advanced';
export const QUOTA_TYPE_WALKUP_KEY = 'walk-up';
export const QUOTA_TYPE_ADVANCED_LABEL = 'Advanced';
export const QUOTA_TYPE_WALKUP_LABEL = 'Walkup';
export const AVAILABILITY_QUOTA_TYPE_LIST = [
    {
        id: QUOTA_TYPE_ADVANCED,
        label: QUOTA_TYPE_ADVANCED_LABEL,
        key: QUOTA_TYPE_ADVANCED_KEY,
    },
    {
        id: QUOTA_TYPE_WALKUP,
        label: QUOTA_TYPE_WALKUP_LABEL,
        key: QUOTA_TYPE_WALKUP_KEY,
    }
];

// issuance types
export const PERMIT_TYPE_PRIVATE_LABEL = 'Non-Commercial';
export const PERMIT_TYPE_COMMERCIAL_LABEL = 'Commercial';

export const PERMIT_TYPE_COMMERCIAL_KEY = 'commercial';
export const PERMIT_TYPE_NON_COMMERCIAL_KEY = 'non-commercial';

export const PERMIT_TYPE_PRIVATE = 0;
export const PERMIT_TYPE_COMMERCIAL = 1;

export const AVAILABILITY_PERMIT_TYPE_LIST = [
    {
        id: PERMIT_TYPE_PRIVATE,
        label: PERMIT_TYPE_PRIVATE_LABEL,
        key: PERMIT_TYPE_NON_COMMERCIAL_KEY,
    },
    {
        id: PERMIT_TYPE_COMMERCIAL,
        label: PERMIT_TYPE_COMMERCIAL_LABEL,
        key: PERMIT_TYPE_COMMERCIAL_KEY,
    }
];
